/*
 * Modules
 */

/* Internal */

/* Internal Vars */
// import BasketFixedJar from "./jar";

/* Internal Services */
import BasketFixedService from "./service";

/* Internal Storage */
import BasketFixedStorage from "./storage";

/* Internal Factories */
import BasketFixedFactory from "./factory";

/* Facades */
import BasketFixed from "./facade";

const modul = angular

    .module("BasketFixedModule", [])

    /**
     * Internal
     */

    /**
     * Services
     * * can only have utility dependencies
     */
    .factory("BasketFixedService", BasketFixedService)

    /**
     * Storage
     * can only have utility and services as dependencies
     */
    .factory("BasketFixedStorage", BasketFixedStorage)

    /**
     * Factories
     */
    .factory("BasketFixedFactory", BasketFixedFactory)

    /**
     * Facades
     */
    .factory("BasketFixed", BasketFixed);

export default modul.name;
